import { loadTerrain } from '../dem';
import { levelTerrain, LevelId } from './index';

/** Loads whatever a level needs before `new Level(LEVELS[id])` (its terrain grid, if any). Safe to call repeatedly. */
export async function loadLevelData(id: LevelId, base: string = import.meta.env.BASE_URL): Promise<void> {
  const name = levelTerrain(id);
  if (name) await loadTerrain(name, base);
}
